import React from 'react'
import { Box } from '@mui/material'
import { Navbar } from '../component/shared/Navbar'
import { UserForm } from '../component/admin/UserForm'
import { Helmet } from 'react-helmet-async'
import { useSearchParams } from 'react-router-dom'
import { useGetUser } from '../api/user'
import { AdminMenu } from '../component/admin/AdminMenu'

export const EditUserScreen = () => {
  const [searchParams] = useSearchParams()
  const userId = searchParams.get('id')
  const { data } = useGetUser(userId)

  return (
    <Box>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Admin</title>
      </Helmet>
      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <UserForm title={'Edit User'} curData={data} />
      </Box>
    </Box>
  )
}
